import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface VacationBalance {
  employeeId: string
  yearCaused: number
  normalTotalDays: string
  bonusTotalDays: string
  liquidationTotalDays: string
  normalPendingDays: string
  bonusPendingDays: string
  liquidationPendingDays: string
  lastDateCaused: string
  startPeriodDate: string
  closePeriodDate: string
  isClosed: boolean
}

const addHeaders = {
  headers: {
    'x-movement-type': 'MANUAL'
  }
}

export async function getVacationBalances(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['employees.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(CONCAT(employees.code,' - ', employees.name),vacation_balances.year_caused, vacation_balances.normal_pending_days,
      vacation_balances.normal_total_days,
      vacation_balances.bonus_pending_days,
      vacation_balances.bonus_total_days,
      vacation_balances.liquidation_pending_days,
      vacation_balances.liquidation_total_days) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by vacation_balances.updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_vacation_balances'],
    fields: [
      'vacation_balances.id',
      "CONCAT(employees.code,' - ', employees.name) as employee_name",
      'vacation_balances.year_caused',
      'vacation_balances.normal_pending_days',
      'vacation_balances.normal_total_days',
      'vacation_balances.bonus_pending_days',
      'vacation_balances.bonus_total_days',
      'vacation_balances.liquidation_pending_days',
      'vacation_balances.liquidation_total_days',
      'vacation_balances.start_period_date',
      'vacation_balances.close_period_date',
      'vacation_balances.is_closed',
      'vacation_balances.updated_at'
    ],
    join: [
      'INNER JOIN employees ON vacation_balances.employee_id = employees.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getVacationBalance(id: string): Promise<VacationBalance> {
  const data = await getData<any>({
    tables: ['pg_vacation_balances'],
    fields: [
      'vacation_balances.id',
      'vacation_balances.payroll_id as payrollId',
      'vacation_balances.employee_id as employeeId',
      'vacation_balances.year_caused as yearCaused',
      'vacation_balances.normal_total_days as normalTotalDays',
      'vacation_balances.bonus_total_days as bonusTotalDays',
      'vacation_balances.liquidation_total_days as liquidationTotalDays',
      'vacation_balances.normal_pending_days as normalPendingDays',
      'vacation_balances.bonus_pending_days as bonusPendingDays',
      'vacation_balances.liquidation_pending_days as liquidationPendingDays',
      "TO_CHAR(vacation_balances.last_date_caused,'yyyy-mm-dd') as lastDateCaused",
      "TO_CHAR(vacation_balances.start_period_date,'yyyy-mm-dd') as startPeriodDate",
      "TO_CHAR(vacation_balances.close_period_date,'yyyy-mm-dd') as closePeriodDate",
      'vacation_balances.is_closed as isClosed',
      'vacation_balances.custom_fields as custom'
    ],
    // join: [
    //   'INNER JOIN managements ON  managements.id = departments.management_id'
    // ],
    where: [`vacation_balances.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createVacationBalance(
  data: VacationBalance
): Promise<boolean> {
  const response: any = await http.post(
    'vacation/periods',
    {
      employeeId: data.employeeId,
      normalTotalDays: data.normalTotalDays,
      bonusTotalDays: data.bonusTotalDays,
      liquidationTotalDays: data.liquidationTotalDays,
      normalPendingDays: data.normalPendingDays,
      bonusPendingDays: data.bonusPendingDays,
      liquidationPendingDays: data.liquidationPendingDays,
      lastDateCaused: data.lastDateCaused,
      startPeriodDate: data.startPeriodDate,
      closePeriodDate: data.closePeriodDate,
      isClosed: data.isClosed,
      customFields: {
        ...getCustomProps(data)
      }
    },
    addHeaders
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateVacationBalance(
  data: VacationBalance,
  id: string
): Promise<boolean> {
  const response: any = await http.put(
    'vacation/periods/' + id,
    {
      employeeId: data.employeeId,
      normalTotalDays: data.normalTotalDays,
      bonusTotalDays: data.bonusTotalDays,
      liquidationTotalDays: data.liquidationTotalDays,
      normalPendingDays: data.normalPendingDays,
      bonusPendingDays: data.bonusPendingDays,
      liquidationPendingDays: data.liquidationPendingDays,
      lastDateCaused: data.lastDateCaused,
      startPeriodDate: data.startPeriodDate,
      closePeriodDate: data.closePeriodDate,
      isClosed: data.isClosed,
      customFields: {
        ...getCustomProps(data)
      }
    },
    addHeaders
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteVacationBalance(id: string): Promise<boolean> {
  const response: any = await http.delete('vacation/periods/' + id, addHeaders)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
